export default {
    computed: {
        /**
         * Return the support email.
         *
         * @return {array}
         */
        supportEmail() {
            return process.env.VUE_APP_SUPPORT_EMAIL;
        },

        /**
         * Return the support phone.
         *
         * @return {array}
         */
        supportPhone() {
            return process.env.VUE_APP_SUPPORT_PHONE;
        },

        /**
         * Return the support phone href.
         *
         * @return {array}
         */
        supportPhoneHref() {
            return process.env.VUE_APP_SUPPORT_PHONE_HREF;
        }
    }
};
